// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"945bc628","159":"e1bda866","241":"af4a0bb9","750":"2cd140d4","979":"fa95b973"}[chunkId] + ".chunk.js";
};